export function ctaCopyToConnect(shortName) {
  return shortName ? `Connect ${shortName}` : "Connect"
}

export function storageIdentifier(appletSlug, sessionId) {
  return `connectionId-${appletSlug}-${sessionId}`
}

export function isChannelAccessBlocked(enablementRules) {
  return enablementRules?.block_user && enablementRules?.block_reason === "channel_access"
}

const ENABLEMENT_UPGRADE_REASONS = new Set(["applet_features", "applet_quota"])

export function requiresEnablementUpgrade(enablementRules) {
  return enablementRules?.block_user && ENABLEMENT_UPGRADE_REASONS.has(enablementRules?.block_reason)
}

export function getTargetPlanName(minimumTier) {
  if (minimumTier === "intermediate_pro") return "Pro"
  if (minimumTier === "pro") return "Pro+"
  return "Pro"
}

export function enableCtaLabel({ eligibleForTrial, minimumTier }) {
  const targetPlan = getTargetPlanName(minimumTier)
  return eligibleForTrial ? "Start free trial" : `Upgrade to ${targetPlan}`
}

export function enableUpgradeCancelMessage({ eligibleForTrial, minimumTier }) {
  const targetPlan = getTargetPlanName(minimumTier)

  if (eligibleForTrial) {
    return "A free trial is required to enable this Applet. Click the button below when you're ready."
  }

  return `Upgrade to ${targetPlan} to enable this Applet. Click the button below when you're ready.`
}

export function showEnableUpgradeCancelFlash({ eligibleForTrial, minimumTier }) {
  safeAppendFlash(enableUpgradeCancelMessage({ eligibleForTrial, minimumTier }))
}

// Guidance flash after the user dismisses the enablement paywall without upgrading.
// `suppressCancelFlash` is set during checkout success because the modal calls
// onUpgrade() then onClose() back-to-back — without suppression, users who just
// paid would see "A free trial is required…". `cancelFlashState.shown` limits
// the guidance flash to once per paywall open; callers should clear `.shown`
// when opening the paywall again so a later dismiss can flash once more.
export function handleEnablePaywallModalClose({
  suppressCancelFlash,
  cancelFlashState,
  showCancelFlash,
  onDismiss,
}) {
  onDismiss?.()

  if (!suppressCancelFlash && !cancelFlashState.shown) {
    showCancelFlash()
    cancelFlashState.shown = true
  }
}

export const ENABLE_UPGRADE_PROCESSING_MESSAGE =
  "Your upgrade is processing. Please try enabling again in a moment."

export const ENABLE_UPGRADE_REFRESH_FAILED_MESSAGE =
  "We couldn't refresh your account after upgrade. Please try again."

export function safeAppendFlash(message, severity) {
  if (typeof window.appendFlash !== "function") return

  if (severity) {
    window.appendFlash(message, severity)
  } else {
    window.appendFlash(message)
  }
}

export function handleEnablementUpgradeReloadResult({ data, resetSkipFlag, onComplete }) {
  resetSkipFlag?.()

  const enablementRules = data.applet.normalized_applet.enablement_rules
  const stillBlocked = requiresEnablementUpgrade(enablementRules)

  if (stillBlocked) {
    safeAppendFlash(ENABLE_UPGRADE_PROCESSING_MESSAGE, "warning")
  }

  onComplete({ data, enablementRules, stillBlocked })
}

export function handleEnablementUpgradeReloadError({ resetSkipFlag, onError }) {
  resetSkipFlag?.()
  safeAppendFlash(ENABLE_UPGRADE_REFRESH_FAILED_MESSAGE, "danger")
  onError?.()
}
